var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isClient)?_c('nuxt-link',{staticClass:"container--box-card-custom-outlet-link",attrs:{"to":_vm._f("currentPermalink")(_vm.item,
        _vm.$t(`router.product_permalink.type.${_vm.item.type}`),
        _vm.isOutlet,
        _vm.routeName
      )},nativeOn:{"click":function($event){return _vm.handlerClick(_vm.item)}}},[_vm._t("default")],2):_c('div',{staticClass:"container--box-card-custom-outlet-link"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }